import { useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import Avatardefault from "../../../../statics/illustrations/UserDefault.svg";
import { updateEmployee } from "../../../../store/employee";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { updateProfile } from "../../../../store/user";
import Addressinput from "../../profile/addressInput";
import Groupstates from "../../profile/groupStates";
import Phoneinput from "../../profile/phoneInput";

export type FormValues = {
  email: string;
  name: string;
  email_alternative: string;
  title: string;
  phone: string;
  employee_ext: string;
  employee_suit: string;
  employee_city: string;
  employee_state: string;
  employee_zip_code: string;
  address: string;
  address_2: string;
};

const UpdateEmployee = () => {
  const dispatch = useAppDispatch();
  /* dev varible */
  // const  QA = process.env.REACT_APP_QA
  const { detailEmployee } = useAppSelector((state) => state.employee);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
    // console.log(data);

    dispatch(
      updateEmployee({
        id_encrypted: detailEmployee?.id_encrypted || "",
        send: data,
      })
    );

    // if (file !== "") {
    //   await dispatch(
    //     updateProfile({
    //       ...data,
    //     })
    //   );

    // } else {
    //   await dispatch(
    //     updateProfile({  ...data })
    //   );

    // }
  };

  useEffect(() => {
    setValue("name", detailEmployee?.name || "");
    setValue("email", detailEmployee?.email || "");
    setValue(
      "email_alternative",
      detailEmployee?.extra.email_alternative || ""
    );
    setValue(
      "title",
      detailEmployee?.extra?.title
        ? detailEmployee?.extra?.title
        : detailEmployee?.employee.title || ""
    );
    setValue(
      "address",
      detailEmployee?.extra?.address
        ? detailEmployee?.extra?.address
        : detailEmployee?.employee.location_address1 || ""
    );
    /*     setValue('employee_ext', extra?.employee_ext?extra?.employee_ext: employee.work_extension) */
    setValue(
      "employee_ext",
      detailEmployee?.extra?.employee_ext
        ? detailEmployee?.extra?.employee_ext
        : "" || ""
    );
    setValue(
      "employee_suit",
      detailEmployee?.extra?.employee_suit
        ? detailEmployee?.extra?.employee_suit
        : detailEmployee?.employee.location_address2
        ? detailEmployee?.employee.location_address2
        : "" || ""
    );
    setValue(
      "employee_state",
      detailEmployee?.extra?.employee_state
        ? detailEmployee?.extra?.employee_state
        : detailEmployee?.employee.state || ""
    );
    setValue(
      "employee_zip_code",
      detailEmployee?.extra?.employee_zip_code
        ? detailEmployee?.extra?.employee_zip_code
        : detailEmployee?.employee.zip_code || ""
    );
    setValue(
      "employee_city",
      detailEmployee?.extra?.employee_city
        ? detailEmployee?.extra?.employee_city
        : detailEmployee?.employee.city || ""
    );
    setValue(
      "email_alternative",
      detailEmployee?.extra?.email_alternative
        ? detailEmployee?.extra?.email_alternative
        : "" || ""
    );
    setValue(
      "address_2",
      detailEmployee?.extra?.address_2
        ? detailEmployee?.extra?.address_2
        : "" || ""
    );
  }, [detailEmployee]);

  const checkKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") e.preventDefault();
  };

  // useEffect(() => {
  //   if (status === "updateProfile_success") {
  //     successUpdateProfile();
  //     if (id_campaign) {
  //       dispatch(getDetailCampaign({ id_campaign, id_employee }));
  //     }
  //   }
  // }, [status]);

  /* message toaster */

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => checkKeyDown(e)}
        className="c-profile"
      >
        {/*       <div className="c-profile__header">
          <span className="c-profile__title">Settings</span>
      </div> */}
        <div className="c-profile__body">
          <div className="c-profile__item-box-avatar">
            <span className="c-profile__item-title">Avatar</span>
            <div className="c-profile__box-avatar">
              <div className="c-profile__avatar">
                <img
                  className="c-profile__photo"
                  src={
                    detailEmployee?.extra?.avatar
                      ? detailEmployee?.extra?.avatar
                      : Avatardefault
                  }
                  alt="profile detail employee"
                />
              </div>
            </div>
          </div>
          <div className="c-profile__item-box">
            <div className="c-input">
              <div className="c-input__header">
                <span className="c-input__title">Full Name</span>
              </div>
              <input
                type="text"
                className="c-input__input"
                {...register("name")}
              />
            </div>
          </div>
          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">E-Mail</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("email")}
                  disabled
                />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Alternative E-mail</span>
                </div>
                <input
                  type="text"
                  className={`c-input__input ${
                    errors.email_alternative && "c-input__input--error"
                  }`}
                  {...register("email_alternative", {
                    pattern: {
                      message: "enter a valid email_alternative",
                      value: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i,
                    },
                  })}
                />
                <span className="c-input__error">
                  {errors?.email_alternative?.message}
                </span>
              </div>
            </div>
          </div>

          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Title</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("title", {
                    required: true,
                  })}
                />
              </div>
            </div>
            <div className="c-profile__colum">
              <div className="c-profile__item-box-two">
                <div className="c-profile__colum">
                  <Phoneinput
                    register={register}
                    setValue={setValue}
                    phone={
                      detailEmployee?.extra.phone
                        ? detailEmployee.extra.phone
                        : detailEmployee?.employee.work_phone
                    }
                  />
                </div>
                <div className="c-profile__colum">
                  <div className="c-input">
                    <div className="c-input__header">
                      <span className="c-input__title">Extension Phone</span>
                    </div>
                    <input
                      type="text"
                      className="c-input__input"
                      {...register("employee_ext")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <span className="c-profile__subtitle">Location Information</span>
          <div className="c-profile__item-box">
            <div className="c-profile__colum">
              <Addressinput
                register={register}
                setValue={setValue}
                errors={errors}
              />
            </div>
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Suite</span>
                </div>
                <input
                  type="text"
                  className="c-input__input"
                  {...register("employee_suit")}
                />
              </div>
            </div>
          </div>

          <Groupstates
            clearErrors={clearErrors}
            register={register}
            setValue={setValue}
            errors={errors}
            setError={setError}
            watch={watch}
          />
          {/* {status === "updateProfile_rejected" &&
            errorType === ErrorType.ERROR_SERVER && (
              <Message
                type="error"
                message={errorMessage}
                clouse={() => dispatch(resetStatus())}
              />
            )} */}

          <div className="c-profile__footer">
            <button
              type="submit"
              className={
                `c-profile__save-changues `
                // ${
                //   status === "updateProfile_loading" &&
                //   `c-profile__save-changues--disabled`
                // }
              }
            >
              <>Save changes</>
              {/* {status === "updateProfile_loading" ? (
                <>
                  <div className="spiner"></div> loading...
                </>
              ) : (
              )} */}
            </button>
          </div>
        </div>
      </form>
      <Toaster
        containerStyle={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </>
  );
};

export default UpdateEmployee;
